import { EncryptStorage } from "encrypt-storage";
import { LOCAL_STORAGE_ENCRYPTION_KEY } from "../config";

const encryptedLocalStorageInstance = new EncryptStorage(
  process.env.REACT_APP_ENCRYPT_STORAGE_SECRET ||
    "Socomplexsecretthatnobodywilleverknow"
); 

// Define utility functions directly
export const localStorageInstance = {
  setItem: (key, value) => encryptedLocalStorageInstance.setItem(key, value),
  getItem: (key) => encryptedLocalStorageInstance.getItem(key),
  removeItem: (key) => encryptedLocalStorageInstance.removeItem(key),
  clear: () => encryptedLocalStorageInstance.clear(),
};
